import { render } from "./add-week-schedule-dialog.vue?vue&type=template&id=5b4b3b6e&scoped=true"
import script from "./add-week-schedule-dialog.vue?vue&type=script&lang=js"
export * from "./add-week-schedule-dialog.vue?vue&type=script&lang=js"

import "./add-week-schedule-dialog.vue?vue&type=style&index=0&id=5b4b3b6e&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b4b3b6e"]])

export default __exports__